/**
 * Adjustment-import-only invalidity codes.
 * Reuses settings-import string values for shared checks; DUPLICATE_PART_ROW stays local
 * so settings Import PreventionInvalidityCode is unchanged.
 */
export const AdjustmentPreventionInvalidityCode = {
    INVALID_PART: 'INVALID_PART',
    INVALID_WAREHOUSE: 'INVALID_WAREHOUSE',
    SERIAL_COUNT_MISMATCH: 'SERIAL_COUNT_MISMATCH',
    DUPLICATE_PART_ROW: 'DUPLICATE_PART_ROW',
};
